
export const countEffectiveFilesA = (files, extractedFiles) => {
  const allFiles = [...files, ...extractedFiles];
  const uniquePaths = new Set();
  let emptyPathCount = 0;
  allFiles.forEach(({ filePath }) => {
    if (filePath && filePath.trim()) {
      uniquePaths.add(filePath.trim());
    } else {
      emptyPathCount += 1; // each empty path is counted individually
    }
  });
  const totalFileCount = uniquePaths.size + emptyPathCount;
  return totalFileCount;

}

export const countEffectiveFiles = (files, extractedFiles) => {
  const extractedPaths = extractedFiles.map(file => (file?.path||file?.webkitRelativePath));
  const extractedPathSet = new Set(extractedPaths);
  let count = 0;

  for (const file of files) {
    const isZip = (file?.path||file?.webkitRelativePath).toLowerCase().endsWith('.zip');

    if (!isZip) {
      count++;
    } else {
      const hasChildren = extractedPaths.some(p => p.startsWith((file?.path||file?.webkitRelativePath) + '/'));
      if (!hasChildren) {
        count++; // Count zip if it has no extracted children
      }
    }
  }

  for (const file of extractedFiles) {
    const isZip = (file?.path||file?.webkitRelativePath).toLowerCase().endsWith('.zip');
    const hasChildren = extractedPaths.some(p => p.startsWith((file?.path||file?.webkitRelativePath) + '/'));

    if (!isZip || (isZip && !hasChildren)) {
      count++;
    }
  }

  return count;
};
export const getMimeType = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();
  const mimeTypes = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    xlsm: "application/vnd.ms-excel.sheet.macroEnabled.12",
    csv: "text/csv",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ppt: "application/vnd.ms-powerpoint",
    txt: "text/plain",
    pbix: "application/octet-stream", // PBIX doesn't have a widely recognized MIME type
    xls: "application/vnd.ms-excel", // 
    pptm: "application/vnd.ms-powerpoint.presentation.macroEnabled.12", // Added
  };
  return mimeTypes[ext] || "application/octet-stream"; // Default if unknown
};
export const extractFilesRecursively = (folderContent) => {
  let files = [];

  Object.values(folderContent).forEach(item => {
    if (item instanceof File) {
      //item.path = `${leadingPath}/${item.path}`.replace("//", "/");
      files.push(item);
    } else if (typeof item === "object" && item !== null) {
      files = files.concat(extractFilesRecursively(item));
    }
  });

  return files;
};
export const addToStructure = (structure, pathParts, file, isProtected = false, protectedFilePath = "") => {
  let currentLevel = structure;
  let accumulatedPath = "";

  pathParts.forEach((part, index) => {
    const cleanPart = part.replace(/^\/+|\/+$/g, "");
    accumulatedPath += (accumulatedPath ? "/" : "") + cleanPart;

    if (index === pathParts.length - 1) {
      // Store file as an object with path
      if (isProtected) {
        currentLevel[cleanPart] = { file, isFileProtected: true, path: protectedFilePath, isPartZip: true };

      }
      else {
        currentLevel[cleanPart] = { file, path: (file?.path||file?.webkitRelativePath), isPartZip: true };
      }
    } else {
      if (!currentLevel[cleanPart]) currentLevel[cleanPart] = {
        isPartZip: true,
        path: accumulatedPath
      };;
      currentLevel = currentLevel[cleanPart];
    }
  });
};

export const countFilesRecursively = (folder) => {
  return Object.entries(folder)
    .filter(([key, value]) => typeof value === "object" && value !== null)
    .reduce((count, [key, content]) => {
      if (key === "path" || key === "error" || key === "isPartZip" || key === "isLocked" || key === 'webkitRelativePath') {
        return count; // Skip metadata keys
      }

      // If the object has a 'path' and not any nested keys, it's a file
      const isFile = ("path"||'webkitRelativePath') in content && !Object.values(content).some(val => typeof val === "object" && val !== null && ("path"||'webkitRelativePath') in val);

      // If it's a zip file with files inside, skip counting it
      const isZip = key.endsWith(".zip");
      const hasNestedFiles = Object.keys(content).some(childKey => {
        const child = content[childKey];
        return child && typeof child === "object" && ("path"||'webkitRelativePath') in child;
        // typeof content[childKey] === "object" && "path" in content[childKey]
      }
      );

      if (isZip && hasNestedFiles) {
        // Skip the zip itself, but count its inner contents
        return count + countFilesRecursively(content);
      }

      if (isFile) {
        return count + 1;
      }

      return count + countFilesRecursively(content);
    }, 0);
};

// fileUtils.js
export const getImagePath = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  const imagePaths = {
    'xlsx': require("../images/excel.png"),
    'xls': require("../images/excel.png"),
    'xlsb': require("../images/excel.png"),
    'xlsm': require("../images/excel.png"),
    'csv': require("../images/excel.png"),
    'pdf': require("../images/pdf.png"),
    'docx': require("../images/word.png"),
    'doc': require("../images/word.png"),
    'zip': require("../images/zip.png"),
    'pptx': require("../images/ppt.png"),
    'pptm': require("../images/ppt.png"),
    'ppt': require("../images/ppt.png"),
    'txt': require("../images/txt.png"),
    'pbix': require("../images/powerbi.png"),
  };

  // Fallback image if extension not found
  return imagePaths[extension] ? imagePaths[extension] : require("../images/FileImage.svg").default;
};
export const getFileTypeName = (fileName) => {
  const extension = fileName.split('.').pop().toLowerCase();
  const fileTypeNames = {
    'xlsx': 'Excel',
    'xls': 'Excel',
    'xlsb': 'Excel',
    'xlsm': 'Excel',
    'csv': 'Excel',
    'pdf': 'PDF',
    'docx': 'Word',
    'doc': 'Word',
    'pptx': 'PPT',
    'ppt': 'PPT',
    'zip': 'ZIP',
    'txt': 'Text',
    'pbix': 'Power BI',
    'pptm': 'PPT'
  };
  return fileTypeNames[extension] || extension.toUpperCase();
};

export const svgSrc = (svg) => {
  const str = svg.toString();
  return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(str)));
};

export const getDateTimeFormat = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[d.getMonth()];
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convert to 12-hour format
  return `${hours}:${minutes} ${ampm} | ${day}-${month}-${year}`;
};

export const getUploadedByFormat = (uploadedBy) => {
  if (!uploadedBy) return "";
  return uploadedBy
    .replace(/@.*$/, "")
    .replace(/\d+/g, "")
    .replace(/[._]/g, " ")
    .replace(/\b([a-zA-Z])/g, (m) => m.toUpperCase())
    .trim();
}

// Returns a short abbreviation for the user's local timezone (e.g. "IST", "UTC", "PST").
// Prefers the browser-provided short name when it is not a bare "GMT+HH:MM" offset,
// otherwise derives an acronym from the long name ("India Standard Time" -> "IST").
export const getUserTimezoneAbbr = () => {
  try {
    const now = new Date();
    const shortParts = new Intl.DateTimeFormat("en-US", { timeZoneName: "short" }).formatToParts(now);
    const shortName = shortParts.find((p) => p.type === "timeZoneName")?.value || "";
    if (shortName && !/^GMT[+-]/i.test(shortName) && !/^UTC[+-]/i.test(shortName)) {
      return shortName;
    }
    const longParts = new Intl.DateTimeFormat("en-US", { timeZoneName: "long" }).formatToParts(now);
    const longName = longParts.find((p) => p.type === "timeZoneName")?.value || "";
    if (/^Coordinated Universal Time$/i.test(longName)) return "UTC";
    const acronym = longName.split(/\s+/).filter((w) => /^[A-Z]/.test(w)).map((w) => w[0]).join("");
    return acronym || shortName || "";
  } catch (e) {
    return "";
  }
};